/**
 * @generated SignedSource<<6532ca1a791f01a6cf23674d3bca1f14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProductName = "artist" | "partner" | "partner_enterprise";
import { FragmentRefs } from "relay-runtime";
export type ManageSubscription_user$data = {
  readonly availableProductName: ProductName;
  readonly availableSubscriptionPrices: ReadonlyArray<{
    readonly id: string | null;
    readonly period: string | null;
    readonly price: number | null;
  } | null> | null;
  readonly id: string;
  readonly stripePriceId: string | null;
  readonly " $fragmentType": "ManageSubscription_user";
};
export type ManageSubscription_user$key = {
  readonly " $data"?: ManageSubscription_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ManageSubscription_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ManageSubscription_user",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availableProductName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stripePriceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PriceOption",
      "kind": "LinkedField",
      "name": "availableSubscriptionPrices",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "price",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "period",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserNode",
  "abstractKey": null
};
})();

(node as any).hash = "f42f30301f6d2eae8d587c3c7f777bb9";

export default node;
